import { createLink } from '@tanstack/react-router';

import { LinkTextButton, type LinkTextButtonProps } from '@/libs/serenity-ui';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const RouterTextButtonLink = createLink(({ className, ...props }: Omit<LinkTextButtonProps, 'style'> & { className?: string }) => <LinkTextButton {...props} />);
